module.exports = __webpack_public_path__ + "static/6-cab395820359ac8db5e8e833c1f43531.jpg";